export const actionTypes = {
  INIT: 'INIT',
  ROUTE_CHANGE: 'ROUTE_CHANGE',
  APP_IS_LOADING: 'APP_IS_LOADING',
  APP_DONE_LOADING: 'APP_DONE_LOADING',
  SHOW_LOGOUT_DIALOG: 'SHOW_LOGOUT_DIALOG',
  HIDE_LOGOUT_DIALOG: 'HIDE_LOGOUT_DIALOG',
  SERVICE_REQUEST_UPDATE: 'SERVICE_REQUEST_UPDATE',
  SET_SHOW_DRAWER: 'SET_SHOW_DRAWER',
};

export const routeChange = (value) => {
  return {type: actionTypes.ROUTE_CHANGE, value};
};

export const serviceRequestUpdate = (value) => {
  return {
    type: actionTypes.SERVICE_REQUEST_UPDATE,
    value,
  };
};

export const setAppIsLoading = () => {
  return {
    type: actionTypes.APP_IS_LOADING,
  };
};

export const setAppDoneLoading = () => {
  return {
    type: actionTypes.APP_DONE_LOADING,
  };
};

export const showLogoutDialog = () => {
  return {
    type: actionTypes.SHOW_LOGOUT_DIALOG,
    value: true,
  };
};

export const hideLogoutDialog = () => {
  return {
    type: actionTypes.SHOW_LOGOUT_DIALOG,
    value: false,
  };
};

export const setShowDrawer = (value) => {
  return {type: actionTypes.SET_SHOW_DRAWER, value};
};
